import { authorizationHookFactory } from "./hooks/(beforeRequest)/auth";
import { base } from "./base";
import { BASE_CALENDAR_URL } from "./constants";
import { errorToastHook } from "./hooks/(beforeError)/errorToast";
import { loaderEndHook } from "./hooks/(afterResponse)/loaderEnd";
import { loaderErrorHook } from "./hooks/(beforeError)/loaderError";
import { loaderStartHook } from "./hooks/(beforeRequest)/loaderStart";
import { refreshAuthTokenHook } from "./hooks/(afterResponse)/refreshAuthToken";

const authorizationHook = authorizationHookFactory(() => localStorage.getItem("token"));

// Authenticated calendar instance — same as httpAuth but targets the calendar base URL
export const httpCalendar = base.extend({
  hooks: {
    afterResponse: [loaderEndHook, refreshAuthTokenHook],
    beforeError: [loaderErrorHook, errorToastHook],
    beforeRequest: [loaderStartHook, authorizationHook],
  },
  prefix: BASE_CALENDAR_URL,
});
